<template>
	<div class="serviceHall">
		<Carousel :bannerImg="bannerImg" :bannerInfo="bannerInfo" />
		<!-- 分类 -->
		<div class="w tabs flex">
			<div
					:class="['bon', index == tabIdx ? 'bon_cls' : '']"
					v-for="(item, index) in tabList"
					:key="index"
					@click="tabChange(index)"
			>
				{{ item.targetName }}
			</div>
		</div>
		<div class="w service_ti flex">
			<div class="title" style="font-size: 28px">
				服务大厅 <span class="total">共{{ pagination.total }}项</span>
			</div>
			<div>
				<a-checkbox-group
						style="margin-right: 64px"
						v-model="checkbox"
						name="checkboxgroup"
						:options="checkList"
						@change="checkChange"
				/>
				<a-select default-value="0" style="width: 120px" @change="selectChange">
					<a-select-option value="0"> 全部类型</a-select-option>
					<a-select-option value="1"> 办事类</a-select-option>
					<a-select-option value="2"> 应用类</a-select-option>
				</a-select>
				<a-input-search
						style="width: 299px; margin-left: 20px"
						placeholder="请输入你要查询的关键字..."
						enter-button
						:maxLength="30"
						:allowClear="true"
						@search="onSearch"
				/>
			</div>
		</div>

		<!-- 分类 -->
		<div class="w service_class">
			<div class="cls_top" style="border-bottom: 1px solid #ebeffc">
				<div class="cls_le">主管部门：</div>
				<div :class="['flex', 'cls_ct', ifShow ? 'cls_ct2' : 'cls_ct1']">
					<div
							:class="['cls_box', index == classIdx ? 'cls_box_bg' : '']"
							v-for="(item, index) in department"
							:key="item.id"
							@click="classChange(item.id, index)"
					>
						{{ item.name }}
					</div>
				</div>
				<div
						class="cls_rt"
						:style="department.length > 7 ? '' : 'visibility: hidden'"
						@click="changeIfShow(ifShow, 1)"
				>
					<span>{{ ifShow ? "收起" : "更多" }}</span>
					<img
							v-if="!ifShow"
							src="../../assets/icon/icon-triangle-open-gary.png"
							alt=""
					/>
					<img
							v-else
							src="../../assets/icon/icon-triangle-close-blue.png"
							alt=""
					/>
				</div>
			</div>
			<div class="cls_top" style="margin-bottom: 32px">
				<div class="cls_le">所属分类：</div>
				<div :class="['flex', 'cls_ct', ifShow2 ? 'cls_ct2' : 'cls_ct1']">
					<div
							:class="['cls_box', index == classIdx2 ? 'cls_box_bg' : '']"
							v-for="(item, index) in serviceClassify"
							:key="item.id"
							@click="classChange2(item.id, index)"
					>
						{{ item.name }}
					</div>
				</div>
				<div class="cls_rt" :style="serviceClassify.length > 8?'':'visibility: hidden'" @click="changeIfShow(ifShow2, 2)">
          <span :style="ifShow2 ? 'color: var(--themeColor);' : ''">{{
            ifShow2 ? "收起" : "更多"
          }}</span>
					<img
							v-if="!ifShow2"
							src="../../assets/icon/icon-triangle-open-gary.png"
							alt=""
					/>
					<img
							v-else
							src="../../assets/icon/icon-triangle-close-blue.png"
							alt=""
					/>
				</div>
			</div>
		</div>

		<!-- 表格 -->
		<div class="w" style="margin-bottom: 130px" v-if="list.length > 0">
			<a-table
					:columns="columns"
					:data-source="list"
					:loading="loading"
					rowKey="id"
					:pagination="pagination"
					@change="pageChange"
			>
				<template slot="serviceManageName" slot-scope="scope, row">
					<div class="flex table">
						<div>{{ scope }}</div>
						<div class="table_name bg_yel" v-if="row.priority == '1'">推荐</div>
						<div class="table_name bg_red" style="padding: 0;text-align: center;" v-if="row.isLimitTime">限时</div>
						<div class="table_name bd_green" v-if="row.priority == '3'">
							上新
						</div>
					</div>
				</template>
				<template slot="serviceClassifyName" slot-scope="scope">
					<a-space>
						<div v-for="item in scope" :key="item">{{ item }}</div>
					</a-space>
				</template>
				<template slot="manageType" slot-scope="scope">{{
					scope == 1 ? "办事类" : "应用类"
					}}</template>
				<template slot="terminal" slot-scope="scope">
					<img
							v-if="scope != 1"
							src="../../assets/icon-mobile-outline.png"
							alt=""
					/>
					<img v-if="scope != 2" src="../../assets/icon-pc-outline.png" alt="" />
				</template>
				<template slot="operation" slot-scope="scope, row">
					<div class="flex">
						<div class="bon_l" @click="gotoDetails(row)">查看详情</div>
						<div :class="[row.isApply?'bon_r':'disable_class']" @click="gotoWork(row.isApply,row.pcUrl)">{{row.isApply?'线上办理':'线下办理'}}</div>
					</div>
				</template>
			</a-table>
		</div>

		<!-- 无数据 -->
		<img
				v-else
				style="margin-bottom: 120px"
				src="../../assets/no-date.png"
				alt=""
		/>
	</div>
</template>

<script>
  const columns = [
    {
      title: "事项名称",
      dataIndex: "serviceManageName",
      scopedSlots: { customRender: "serviceManageName" },
    },
    {
      title: "主管部门",
      dataIndex: "deptName",
      scopedSlots: { customRender: "deptName" },
    },
    {
      title: "所属分类",
      dataIndex: "serviceClassifyName",
      scopedSlots: { customRender: "serviceClassifyName" },
    },
    {
      title: "事项类型",
      dataIndex: "manageType",
      scopedSlots: { customRender: "manageType" },
    },
    {
      title: "服务终端",
      dataIndex: "terminal",
      scopedSlots: { customRender: "terminal" },
    },
    {
      title: "操作",
      dataIndex: "operation",
      scopedSlots: { customRender: "operation" },
      width:200
    },
  ];
  import {
    findServiceManageApi,
    findDepartmentApi,
    findServiceClassifyApi,
    findTargetsApi,
    findNavBannerApi,
  } from "@/api/index";
  import imgPrefix from "../../../utils/imgPrefix";
  import Carousel from "../../components/Carousel.vue";
  export default {
    props: {},
    components: { Carousel },
    data() {
      return {
        loading: false,
        tabList: [],
        tabIdx: 0,
        checkbox: [],
        ifShow: 0,
        ifShow2: 0,
        checkList: [
          { label: "推荐事项", value: "1" },
          { label: "限时事项", value: "2" },
          { label: "上新事项", value: "3" },
        ],
        department: [],
        serviceClassify: [],
        classIdx: 0,
        classIdx2: 0,
        page: 1,
        pageSize: 10,
        pagination: {
          total: 0,
          current: 1,
          showTotal: (total) => `当前有${total}条部门记录  显示 1~10条`,
        },
        columns,
        list: [],
        form: {
          isLimitTime: false,
        },
        bannerImg: [],
        bannerInfo: {
          title: "服务大厅",
          desc: "业务主题集合专区，推进“一门式、一网式”校务服务模式，让师生少跑腿、好办事、办好一件事。",
        },
        imgPrefix,
      };
    },
    computed: {},
    watch: {},
    created() {
      // 获取服务对象
      findTargetsApi().then((res) => {
        // console.log(res);
        this.tabList = res;
      });
      // 获取部门
      findDepartmentApi().then((res) => {
        res.unshift({ id: "", name: "全部" });
        this.department = res;
      });
      // 获取所属分类
      findServiceClassifyApi().then((res) => {
        // console.log(res);
        res.unshift({ id: "", name: "全部" });
        this.serviceClassify = res;
      });
      this.getfindServiceManage();
      this.getBanner();
    },
    mounted() {},
    methods: {
      // 获取服务大厅列表数据
      getfindServiceManage() {
        let dto = Object.assign({}, this.form);
        dto.page = this.page;
        dto.pageSize = this.pageSize;
        this.loading = true;
        // console.log(dto);
        findServiceManageApi(dto)
          .then((res) => {
            // console.log(res);
            this.list = res.voList.list;
            this.pagination.total = res.voList.total;
            this.pagination.current = res.voList.page;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error(err.message);
          });
      },
      // 获取banner
      getBanner() {
        let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
        if (naviTop) {
          naviTop.forEach((item) => {
            if (item.link == "/serviceHall") {
              findNavBannerApi(item.id)
                .then((res) => {
                  // console.log(res);
                  this.bannerImg = res;
                })
                .catch((err) => {
                  this.$message.error(err.message);
                });
            }
          });
        }
      },
      tabChange(idx) {
        this.tabIdx = idx;
        this.$forceUpdate();
        this.form.targets = `[${idx}]`;
        this.page = 1;
        this.getfindServiceManage();
      },
      onSearch(e) {
        // console.log(e);
        this.page = 1;
        this.form.keyword = e;
        this.getfindServiceManage();
      },
      // 选择事项
      checkChange(checkedValues) {
        // console.log(checkedValues);
        let arr = checkedValues.filter((item) => {
          return item != 2;
        });
        this.form.priority = arr;
        if (checkedValues.indexOf("2") != -1) {
          this.form.isLimitTime = true;
        } else {
          this.form.isLimitTime = false;
        }
        this.page = 1;
        this.getfindServiceManage();
      },
      selectChange(e) {
        this.form.manageType = e == "0" ? null : e;
        this.page = 1;
        this.getfindServiceManage();
      },
      // 切换主管部门
      classChange(id, idx) {
        this.classIdx = idx;
        this.form.deptId = id;
        this.page = 1;
        this.getfindServiceManage();
      },
      // 切换所属分类
      classChange2(id, idx) {
        this.classIdx2 = idx;
        this.form.classifyId = id;
        this.page = 1;
        this.getfindServiceManage();
      },
      // 查看指南
      gotoDetails(e) {
        let naviTop = JSON.parse(sessionStorage.getItem("naviArr"));
        let idx = "";
        if (naviTop) {
          naviTop.forEach((item, index) => {
            if (item.link == "/serviceHall") {
              idx = index;
            }
          });
        }
        this.$router.push(
          "/serviceDetails?index=" + idx + "&serviceManageId=" + e.id
        );
      },
      // 办理链接
      gotoWork(isApply,url) {
        if(isApply){
          window.open(url);
        }
      },
      changeIfShow(e, val) {
        if (val == 1) {
          this.ifShow = e == 0 ? 1 : 0;
        } else {
          this.ifShow2 = e == 0 ? 1 : 0;
        }
      },
      pageChange(pagination) {
        this.page = pagination.current;
        this.getfindServiceManage();
      },
    },
  };
</script>

<style scoped lang="less">
	.serviceHall {
		// .ban_r {
		//   width: 43%;
		//   height: 272px;
		//   background: url("../../assets/sevice.png") no-repeat right;
		// }
		.tabs {
			border-radius: 8px;
			justify-content: center;
			margin-bottom: 75px;
			margin-top: 40px;
			.bon {
				padding: 13px 30px;
				font-size: 18px;
				cursor: pointer;
				background: rgb(244, 246, 253);
				border-radius: 8px;
				margin-right: 20px;
				color: #7a8ba4;
				// &:first-child {
				//   border-radius: 8px 0 0 8px;
				// }
				// &:last-child {
				//   border-radius: 0 8px 8px 0;
				// }
			}
			.bon_cls {
				background: var(--themeColor);
				color: #fff;
			}
		}
		.title {
			font-weight: 700;
			font-size: 32px;
			color: #0d1c28;
			text-align: left;
			.total {
				font-size: 18px;
				color: #7a8ba4;
				font-weight: 500;
			}
		}
		.service_ti {
			justify-content: space-between;
			padding-bottom: 1%;
			// margin-top: 3%;
		}
		.service_class {
			background: #f7f8fb;
			border-radius: 8px;
			.cls_top {
				padding-bottom: 12px;
				padding-top: 10px;
				display: flex;
				.cls_box {
					padding: 6px 0;
					margin-right: 32px;
					cursor: pointer;
				}
				.cls_box_bg {
					// background: rgba(8, 102, 180, 0.2);
					border-bottom: 2px solid var(--themeColor);
					color: var(--themeColor);
				}
				.cls_le {
					margin-right: 10px;
					flex: 1;
					line-height: 36px;
					color: #7a8ba4;
				}
				.cls_rt {
					flex: 1;
					cursor: pointer;
					line-height: 34px;
					color: #7a8ba4;
					img {
						margin-left: 14px;
					}
				}
				.cls_ct {
					overflow: hidden;
					flex-wrap: wrap;
					flex: 8;
				}
				.cls_ct1 {
					height: 36px;
				}
				.cls_ct2 {
					// height: 68px;
				}
			}
		}
		.table div {
			margin-right: 10px;
		}
		.table_name {
			color: #fff;
			font-size: 12px;
			padding: 0 3px;
			border-radius: 2px;
		}
		.bg_red {
			background: #ff0000;
			width: 33px;
		}
		.bg_yel {
			background: #ff8a00;
		}
		.bd_green {
			border: 1px solid #008d1f;
			color: #008d1f;
		}
		.icon_img {
			background: #f7f8fb;
			border-radius: 4px;
			padding: 6px 12px;
		}
		.bon_l {
			border: 1px solid var(--themeColor);
			border-radius: 8px;
			padding: 5px 7px;
			color: var(--themeColor);
			margin-right: 12px;
			cursor: pointer;
			text-align: center;
		}
		.bon_r {
			color: #fff;
			background: var(--themeColor);
			border-radius: 8px;
			padding: 6px 8px;
			cursor: pointer !important;
		}

		/deep/.ant-btn-primary {
			background: var(--themeColor);
		}
		/deep/.ant-table-pagination.ant-pagination {
			display: flex;
			float: none;
		}
		/deep/.ant-pagination-total-text {
			flex: 1;
			text-align: left;
			font-weight: 500;
			margin-left: 16px;
		}
		/deep/.ant-table-thead > tr > th {
			color: #7a8ba4;
		}
		/deep/.ant-table-tbody > tr > td{
			padding: 16px 6px !important;
		}
	}
</style>
